/**
 * This events search module works on top of "PCG.UmbracoPlugins.EventsSearch" plugin.
 * It is used on the "Digital Inclusion" microsite. See "EventsSearchPage_TrainingMicrosite" for details.
 */

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GoogleMapsModule } from "@angular/google-maps";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { NouisliderModule } from "ng2-nouislider";

import { MapViewComponent } from "./components/map-view/map-view.component";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { CategoriesFilterComponent } from "./components/search-filters/categories-filter/categories-filter.component";
import { CheckboxComponent } from "./components/search-filters/categories-filter/checkbox/checkbox.component";
import { DatesFilterComponent } from "./components/search-filters/dates-filter/dates-filter.component";
import { PostcodeFilterComponent } from "./components/search-filters/postcode-filter/postcode-filter.component";
import { SearchFiltersComponent } from "./components/search-filters/search-filters.component";
import { ResultItemComponent } from "./components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";
import { EventsSearchComponent } from "./events-search.component";

@NgModule({
    imports: [
        CommonComponentsModule,
        CommonModule,
        GoogleMapsModule,
        NouisliderModule
    ],
    declarations: [
        CategoriesFilterComponent,
        CheckboxComponent,
        DatesFilterComponent,
        EventsSearchComponent,
        MapViewComponent,
        PaginationComponent,
        PostcodeFilterComponent,
        ResultItemComponent,
        SearchFiltersComponent,
        SearchResultsComponent
    ],
    exports: [
        EventsSearchComponent
    ]
})
export class EventsSearchModule {
}
